import { Event } from './event';

export interface EventStreamListener {
  readonly events?: string[] | 'all';

  handle(event: Event): void;
}

export const EventStreamListenerSymbol = Symbol.for('EventStreamListener');
